import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_URL, getAuthConfig, StatCard, Row, labRoleLabel } from "./shared";

/*
 * Tableau de bord du jour (cahier des charges labo, section 5). Port de
 * LabOverview (frontend/src/pages/HopitalDashboard.js) sur les routes
 * dédiées : /api/lab/reception/stats au lieu de /api/sih/reception/stats
 * (voir backend/routes/lab/reception.py, PR3b). Calculé à partir des
 * arrivées réelles (reception_queue), pas des rendez-vous : beaucoup de
 * patients de labo n'ont pas de compte ni de RDV en ligne.
 */
export default function LabOverview({ ctx, est }) {
  const [s, setS] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    axios.get(`${API_URL}/api/lab/reception/stats`, getAuthConfig()).then((r) => setS(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);
  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", flexWrap: "wrap", gap: 8 }}>
        <h1 style={{ fontSize: 22, fontWeight: 700, color: "#0F172A", margin: 0 }}>Vue d'ensemble</h1>
        {s && <span style={{ fontSize: 13, color: "#94A3B8" }}>Aujourd'hui · {s.date}</span>}
      </div>

      {loading ? <div style={{ padding: 24, color: "#94A3B8" }}>Chargement des chiffres…</div> : s && (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(190px, 1fr))", gap: 14, marginTop: 18 }}>
          <StatCard label="Patients arrivés" value={s.patients_arrives} accent="#185FA5" />
          <StatCard label="En attente" value={s.en_attente} color={s.en_attente ? "#B45309" : "#0F172A"} accent="#F59E0B" />
          <StatCard label="Pris en charge" value={s.pris_en_charge} accent="#3730A3" />
          <StatCard label="Terminés" value={s.termines} accent="#3B6D11" />
          <StatCard label="Avec RDV" value={s.avec_rdv} sub={`${s.sans_rdv} sans RDV`} accent="#0596DE" />
          <StatCard label="Dossiers incomplets" value={s.dossiers_incomplets} color={s.dossiers_incomplets ? "#A32D2D" : "#0F172A"} accent="#DC2626" />
          <StatCard label="Attente moyenne" value={`${s.temps_attente_moyen_min} min`} accent="#7C3AED" />
          <StatCard label="Prélèvements terminés" value={s.prelevements_termines} accent="#0E7490" />
        </div>
      )}

      <div style={{ background: "#fff", border: "1px solid #E2E8F0", borderRadius: 12, padding: 20, marginTop: 22, maxWidth: 560 }}>
        <div style={{ fontSize: 12, fontWeight: 700, color: "#185FA5", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 8 }}>Établissement</div>
        <Row label="Nom" value={est.name} />
        <Row label="Type" value="Laboratoire" />
        <Row label="Votre rôle" value={labRoleLabel(ctx.establishment_role)} />
        {est.wilaya_code && <Row label="Wilaya" value={est.wilaya_code} />}
        {est.phone && <Row label="Téléphone" value={est.phone} />}
      </div>
    </div>
  );
}
